import React, {useState} from 'react';
import type {Data} from 'schemaDefinition/types';
import {Card, Spacer, Text} from 'components';
import {DataFormV1} from 'schema';
import {bookSchema, editConfiguration, sampleBook} from './demoSchema';

/**
 * Edit mode: `DataFormV1` renders an editable form from `bookSchema` and keeps
 * the edited entity in local state. The JSON of the current value is shown
 * below the form so the binding between schema and data is visible.
 */
export const EditPage: React.FC = () => {
  const [data, setData] = useState<Data>(sampleBook);

  return (
    <>
      <Text variant="body1" kind="secondary">
        {'A schema rendered as an editable form with <DataForm />. Every field, ' +
          'its type and validation comes from the schema definition.'}
      </Text>
      <Spacer size={2} />
      <Card level="level3">
        <Card.Header>
          <Text variant="h2" kind="primary">
            {'Edit book'}
          </Text>
        </Card.Header>
        <Card.Content>
          <DataFormV1
            id="schema-demo-edit"
            mode="edit"
            schema={bookSchema}
            data={data}
            relatedData={{}}
            configuration={editConfiguration}
            onDataChanged={setData}
          />
        </Card.Content>
      </Card>
      <Spacer size={2} />
      <Card level="level3">
        <Card.Header>
          <Text variant="h2" kind="primary">
            {'Current value'}
          </Text>
        </Card.Header>
        <Card.Content>
          <pre style={{margin: 0, whiteSpace: 'pre-wrap'}}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </Card.Content>
      </Card>
    </>
  );
};
